import { useEffect, useRef } from "react";
import { AbortControllerManager } from "./AbortControllerManager";

export const useAbortManager = () => {

    const managerRef = useRef(new AbortControllerManager());

    useEffect(() => {
        const manager = managerRef.current;
        return () => {
            manager.abortAll();
        };
    }, []);

    return managerRef.current;
};
